import axiosAuthConfig from '../../axiosAuthConfig';

export const changePassword = async (data) => {
    try {
        const response = await axiosAuthConfig.post(`/api/user/changePassword`,data); // Call your protected API endpoint
        return response.data; // Return the data from the response
    } catch (error) {
        console.log('Error fetching protected data:', error);
        // throw error; // Handle error appropriately
        
    }
};